import PropTypes from 'prop-types';
import OptionPropType from './option';

const ActivityDefaultProps = {
  id: undefined,
  duration: null,
  band: null,
  requiredClinicians: null,
  timeAverage: null,
  isActive: null,
  ragStatus: null,
  activityType: null,
};

const ActivityPropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string.isRequired,
  requiredClinicians: PropTypes.number,
  duration: PropTypes.number,
  timeAverage: PropTypes.number,
  isActive: PropTypes.bool,

  ragStatus: OptionPropType,
  activityType: OptionPropType,
  band: OptionPropType,
});

export { ActivityDefaultProps, ActivityPropType };
